module.exports = __webpack_public_path__ + "media/images/team/ian-visto-56580e15cc70f348644bd63d2646d84f.png";